import * as React from "react";
import styled from "styled-components";

import {
    LegendLabel,
    Text,
    MarketResearchDiversityMetricData,
} from "../../..";
import {
    DiversityGridBars,
    DiversityGridLabel,
    DiversityMobile,
    DiversitySectionHeaderLabel,
    DiversitySectionHeaderMobile,
} from "./marketResearchDiversity";

type DiversityMobileSectionProps = {
    summaryText: () => JSX.Element;
    title: string;
    graphTitle: string;
    metrics: MarketResearchDiversityMetricData[];
    gauge: React.ReactNode;
    isLocationRemote: boolean;
    bars: (metric: MarketResearchDiversityMetricData) => JSX.Element;
};
export const DiversityMobileSection = (props: DiversityMobileSectionProps) => {
    const {
        summaryText,
        title,
        gauge,
        graphTitle,
        metrics,
        isLocationRemote,
        bars,
    } = props;

    const legend = () => {
        if (isLocationRemote) {
            return null;
        }

        return (
            <DiversityGridLegend>
                <LegendLabel color="#7E66D8" text="Regional" addMargin />
                <LegendLabel color="#E35AFC" text="State" />
            </DiversityGridLegend>
        );
    };

    return (
        <>
            <DiversitySectionHeaderMobile>
                <div>
                    <DiversitySectionHeaderLabel>
                        <Text variant="h3">{title}</Text>
                    </DiversitySectionHeaderLabel>
                    {summaryText()}
                </div>
                <GaugeContainer>{gauge}</GaugeContainer>
            </DiversitySectionHeaderMobile>
            <>
                <DiversitySectionHeaderLabel>
                    <Text variant="h3">{graphTitle}</Text>
                </DiversitySectionHeaderLabel>

                <DiversityMobile>
                    <div>
                        <DiversityGridLabel />
                        {legend()}
                    </div>
                    {metrics.map((metric, index) => (
                        <div key={index}>
                            <Text>
                                <b>{metric.name}</b>
                            </Text>
                            <DiversityGridBars>
                                {bars(metric)}
                            </DiversityGridBars>
                        </div>
                    ))}
                </DiversityMobile>
            </>
        </>
    );
};

const DiversityGridLegend = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const GaugeContainer = styled.div`
    width: 280px;
    margin: 16px auto auto auto;
`;
